"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeFontColorCommand = void 0;
var tslib_1 = require("tslib");
var character_property_descriptor_1 = require("../../../core/model/character/character-property-descriptor");
var color_1 = require("../../../core/model/color/color");
var color_model_info_1 = require("../../../core/model/color/color-model-info");
var change_character_properties_command_base_1 = require("./change-character-properties-command-base");
var ChangeFontColorCommand = (function (_super) {
    tslib_1.__extends(ChangeFontColorCommand, _super);
    function ChangeFontColorCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeFontColorCommand.prototype.getDescriptor = function () {
        return character_property_descriptor_1.CharacterPropertyDescriptor.textColor;
    };
    ChangeFontColorCommand.prototype.getValueForState = function (val) {
        return val ? val.toRgb(this.control.modelManager.model.colorProvider) : undefined;
    };
    ChangeFontColorCommand.prototype.DEPRECATEDConvertOptionsParameter = function (parameter) {
        return color_model_info_1.ColorModelInfo.makeByColor(color_1.ColorHelper.anyToColor(parameter, color_1.ColorHelper.AUTOMATIC_COLOR));
    };
    ChangeFontColorCommand.prototype.isLockUpdateValue = function () {
        return true;
    };
    return ChangeFontColorCommand;
}(change_character_properties_command_base_1.ChangeCharacterPropertiesCommandBase));
exports.ChangeFontColorCommand = ChangeFontColorCommand;
